export function initSearch() {
    const search = document.querySelector(".wa-search")
    if (search) {
        setupSearch(search)
    }
}

function setupSearch(search) {
    const input = search.querySelector('input'),
        results = search.querySelector('.wa-search-results')

    let typingTimer;

    input.addEventListener('keyup', () => {
        clearTimeout(typingTimer);
        if (input.value.trim().length >= 3) {
            typingTimer = setTimeout(getSearchResults, 250);
        }
    })

    input.addEventListener('focus', () => {
        if (input.value) {
            results.classList.add('is--active')
        }
    })

    document.addEventListener('click', (e) => {
        if (e.target !== input) {
            results.classList.remove('is--active')
        }
    })

    function getSearchResults() {
        jQuery.ajax({
            url: RES.ajaxurl,
            method: 'POST',
            data: {
                action: 'searchHandler',
                query: {
                    s: input.value.trim(),
                    excludeIds: search.dataset.excludeIds
                },
            },
        }).done(data => {
            results.innerHTML = data.html
            results.classList.add('is--active')
        }).fail(err => {
            console.log(err)
        })
    }

}
